import { render } from "./ApiDataSource.vue?vue&type=template&id=bc825278"
import script from "./ApiDataSource.vue?vue&type=script&lang=js"
export * from "./ApiDataSource.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjektetRentaCar\\mdsgroup\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__